import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=7faba9b4&scoped=true&"
import script from "./ProductEditor.vue?vue&type=script&lang=js&"
export * from "./ProductEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=7faba9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faba9b4",
  null
  
)

export default component.exports